
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { AccountModal, SettingsModal } from '@/lazy-load-components';

import { ModalHelper } from '@/helpers/modal-helper';
import BasicButton from '@/ui-components/BasicButton.vue';
import { faUserCog } from '@fortawesome/free-solid-svg-icons';
import { useStartingPageExp } from '../experiments/StartingPageExp/composables/useStartingPageExp';
import { StarterPageExpVariants } from '../experiments/StartingPageExp';

const User = namespace('user');

@Component({
	name: 'LoginMenuButtonNew',
	components: {
		BasicButton,
	},
	setup() {
		const { startingPageExpActiveVariant } = useStartingPageExp();
		return {
			startingPageExpActiveVariant,
		};
	},
})
export default class LoginMenuButtonNew extends Vue {
	declare readonly startingPageExpActiveVariant: StarterPageExpVariants;

	faUserCog = faUserCog;

	@Prop({ type: Boolean, default: false }) dark: boolean;

	@User.State loginProgress: boolean;

	@User.Getter isLoggedIn: boolean;
	@User.Mutation SET_LOGIN_PROGRESS: (value: boolean) => void;

	get color() {
		if (
			!!this.startingPageExpActiveVariant &&
			this.startingPageExpActiveVariant !== StarterPageExpVariants.CONTROL
		) {
			return 'ghost';
		}
		return this.dark ? 'tertiary' : 'primary';
	}

	handleAccountClick() {
		ModalHelper.openModal(SettingsModal);
	}

	handleLoginClick() {
		ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'login-modal' }, '', false, [], () =>
			this.SET_LOGIN_PROGRESS(false)
		);
	}
}
